import { t } from 'i18next';
import type { OrderCoordinates } from './location';
import { getOpenStreetMapEmbedUrl } from './location';
import * as s from './styles';

type Props = {
  coordinates: OrderCoordinates;
};

const OrderLocationMap = ({ coordinates }: Props) => {
  const mapUrl = getOpenStreetMapEmbedUrl(coordinates);

  return (
    <s.MapFrame>
      <iframe
        className="order-location-map"
        src={mapUrl}
        title={t('orderLocationMap') as string}
        loading="eager"
      />
    </s.MapFrame>
  );
};

export default OrderLocationMap;
